// TitleBar.js
import React, { useState, useEffect } from "react";
import "./TitleBar.css";
import logo from "./trustavo-logo.jpg";
import LoginForm from "./LoginForm";

const TitleBar = ({ userId, apiKey, apiType, onUserIdChange, onApiKeyChange, onApiTypeChange }) => {
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.classList.contains("user-id")) {
        setShowLogin(true);
      } else if (showLogin && !event.target.closest(".login-form")) {
        setShowLogin(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [showLogin]);

  return (
    <div className="title-bar">
      <a href="https://trustavo.com/" target="_blank">
        <img src={logo} alt="Logo" className="logo" />
      </a>
      <h1 className="title-text">Trustavo AI</h1>
      <div
        onClick={() => {
          setShowLogin(true);
        }}
        className="user-id"
      >
        {userId}
      </div>

      {showLogin && (
        <LoginForm
          currentUserId={userId}
          currentApiKey={apiKey}
          apiType={apiType} // Add this line to pass apiType
          onUserIdChange={onUserIdChange}
          onApiKeyChange={onApiKeyChange}
          onApiTypeChange={onApiTypeChange} // Add this line to pass onApiTypeChange
          setShowLogin={setShowLogin}
        />
      )}
    </div>
  );
};

export default TitleBar;
